import React, { useState } from "react";
import { Link } from "react-router-dom";

const AttendanceCalc = () => {
  const [classesAttended, setClassesAttended] = useState("");
  const [totalClasses, setTotalClasses] = useState("");
  const [leaveDays, setLeaveDays] = useState("");
  const [result, setResult] = useState(null);
  const [isCalculating, setIsCalculating] = useState(false);
  const [resultTone, setResultTone] = useState("warning");
  const [resultNote, setResultNote] = useState("");

  const calculateAttendance = () => {
    setIsCalculating(true);
    const attended = parseFloat(classesAttended) || 0;
    const total = parseFloat(totalClasses) || 0;
    const leaves = parseFloat(leaveDays) || 0;

    const projectedTotal = total + leaves;
    const percentage = ((attended / projectedTotal) * 100).toFixed(2);

    setResult(percentage);
    const value = parseFloat(percentage);
    if (!projectedTotal || Number.isNaN(value)) {
      setResultTone("warning");
      setResultNote("Enter classes and leave days to project attendance.");
    } else if (value >= 80) {
      setResultTone("success");
      setResultNote("Green light - safe zone, limited leave is fine.");
    } else if (value >= 75) {
      setResultTone("warning");
      setResultNote("Amber - plan leaves carefully to stay above 75%.");
    } else {
      setResultTone("danger");
      setResultNote("Red - below 75%. Attend now to bounce back.");
    }
    setTimeout(() => setIsCalculating(false), 160);
  };

  const hasInvalidInputs =
    (classesAttended && parseFloat(classesAttended) < 0) ||
    (totalClasses && parseFloat(totalClasses) < 0) ||
    (leaveDays && parseFloat(leaveDays) < 0);

  const primaryLabel = isCalculating ? "Calculating..." : "Calculate Attendance";

  return (
    <div className="app-shell">
      <main className="page">
        <div className="nav-actions">
          <Link to="/" className="btn btn-ghost">← Home</Link>
          <span className="pill">Attendance Calculator</span>
        </div>

        <header className="page-header">
          <p className="eyebrow">Attendance</p>
          <h1 className="page-title">Project attendance before taking leave</h1>
          <p className="lede">Enter your current numbers to see how planned leave days affect your percentage.</p>
        </header>

        <div className="card">
          <div className="two-col">
            <div className="field">
              <label htmlFor="attended">Classes attended</label>
              <input
                id="attended"
                type="number"
                value={classesAttended}
                onChange={(e) => setClassesAttended(e.target.value)}
                placeholder="Enter attended classes"
                min="0"
              />
            </div>

            <div className="field">
              <label htmlFor="total">Total classes held</label>
              <input
                id="total"
                type="number"
                value={totalClasses}
                onChange={(e) => setTotalClasses(e.target.value)}
                placeholder="Enter total classes"
                min="0"
              />
            </div>

            <div className="field">
              <label htmlFor="leave">Planned leave days</label>
              <input
                id="leave"
                type="number"
                value={leaveDays}
                onChange={(e) => setLeaveDays(e.target.value)}
                placeholder="Enter leave days"
                min="0"
              />
              <div className="inline-hint">Adds to total classes to show projected percentage.</div>
            </div>
          </div>

          <div className="controls">
            <button
              type="button"
              className="btn btn-primary"
              onClick={calculateAttendance}
              disabled={hasInvalidInputs || isCalculating}
            >
              {primaryLabel}
            </button>
          </div>
        </div>

        {result !== null && (
          <div className={`result-card ${resultTone}`}>
            <p className="result-label">Attendance Percentage</p>
            <p className="result-value">{result}%</p>
            <p className="muted">Stay above 75% to remain in the safe zone.</p>
            {resultNote && <p className="muted" style={{ marginTop: 6 }}>{resultNote}</p>}
          </div>
        )}
      </main>
    </div>
  );
};

export default AttendanceCalc;
